import { render, staticRenderFns } from "./DeliverCar.vue?vue&type=template&id=7b4b3aa4&scoped=true&"
import script from "./DeliverCar.vue?vue&type=script&lang=js&"
export * from "./DeliverCar.vue?vue&type=script&lang=js&"
import style0 from "./DeliverCar.vue?vue&type=style&index=0&id=7b4b3aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4b3aa4",
  null
  
)

export default component.exports